import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MessageSquare, CheckCircle2, AlertTriangle, Clock } from 'lucide-react';
import { Card } from '../ui/card';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmt = (n) => { const d = (n || '').replace(/\D/g, '').slice(-10); return d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : n; };

const VIEW = {
  setting_up: [Clock, 'border-amber-300 bg-amber-50/60', 'text-amber-700', 'Setting up your texting number', 'We are getting your number and submitting it for carrier approval. This takes a few minutes.'],
  pending_verification: [Clock, 'border-amber-300 bg-amber-50/60', 'text-amber-700', 'Texting is waiting for carrier approval', 'Carriers usually approve within 3-5 business days (up to 2 weeks). Until then, appointment alerts come to you by email. Texting turns on automatically and we email you when it does.'],
  setup_failed: [AlertTriangle, 'border-red-300 bg-red-50/60', 'text-red-700', "We hit a snag setting up texting", "Our team has been notified and is fixing it. You don't need to do anything."],
  rejected: [AlertTriangle, 'border-red-300 bg-red-50/60', 'text-red-700', 'Carriers asked for changes', 'Our team will correct your details and resubmit. We may reach out if we need anything from you.'],
  active: [CheckCircle2, 'border-green-300 bg-green-50/60', 'text-green-700', 'Texting is live', 'Appointment confirmations, reminders and alerts now go out by text.'],
};

export const SmsStatusCard = ({ businessId }) => {
  const [st, setSt] = useState(null);

  useEffect(() => {
    axios.get(`${API}/business/${businessId}/sms-status`).then((r) => setSt(r.data)).catch(() => {});
  }, [businessId]);

  if (!st?.sms_addon_paid) return null;
  const [Icon, card, color, title, desc] = VIEW[st.sms_status] || VIEW.setting_up;

  return (
    <Card className={`card-modern p-6 mb-6 ${card}`} data-testid="sms-status-card">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-white/70 flex items-center justify-center shrink-0">
          <Icon className={`w-6 h-6 ${color}`} />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground flex items-center gap-2" data-testid="sms-status-title">
            <MessageSquare className="w-4 h-4" /> {title}
          </h3>
          <p className="text-sm text-muted-foreground mt-1">{desc}</p>
          {st.sms_phone_number && <p className="text-sm text-foreground mt-2">Your texting number: <span className="font-semibold" data-testid="sms-number">{fmt(st.sms_phone_number)}</span></p>}
        </div>
      </div>
    </Card>
  );
};
